export const institutionTypes =
  {
    1 : 'School',
    2 : 'Public Library',
    3 : 'Other - Fill in other field'
  };